export const youTubePath = () => "https://youtube.bandnada.com"
export const instagramPath = () => "https://www.instagram.com/bandnada/"

export const bandNadaAppUrl = (bandId) => {
  if (!bandId) return null
  return `nada://b/${bandId}`
}
